import React, {useEffect, useRef, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import styles from "../Admin.module.css";
import CrmUserOptinTable from "../../../components/Admin/Crm/CrmUserOptinTable";
import PaginationBar from "../../../components/Pagination/PaginationBar";
import FilterHamburgerCustom from "../../../components/Filter/FilterHamburgerCustom";
import TitleSecondary from "../../../components/Title/TitleSecondary";
import styles_field from "../../../components/Field/Field.module.css";
import SearchUtilisateur from "../../../components/Search/SearchUtilisateur";
import SearchEntreprise from "../../../components/Search/SearchEntreprise";
import {Field, Form, Formik} from "formik";
import stylesField from "../../../components/Field/Field.module.css";
import {getLabel} from "../../../services/LabelService";

function AdminCrmUserOptinPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [utilisateur, setUtilisateur] = useState(null);
    const [entreprise, setEntreprise] = useState(null);
    const [page, setPage] = useState(parseInt(queryParams.get("page")) || 1);
    const [totalPage, setTotalPage] = useState(null);
    const [totalResult, setTotalResult] = useState(null);
    const [sortBy, setSortBy] = useState([]);
    const prevSortBy = useRef(sortBy);


    const handleSuccess = (children = "Enregistré avec succès") => {
        showModal('success', {children: children, timeout: 4000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 4000});
    };

    const getData = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/crm/user_optin?${queryParams.toString()}`);
            setMyApiData(response.data.myCrmUserOptin);
            setTotalResult(response.data.totalRecords);
            setTotalPage(response.data.totalPages);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putCrmOptin = async ({value, row, target}) => {
        const utilisateurId = row.original.user.id;

        const response = await AxiosConfig.post(`/admin/crm/user_optin/${utilisateurId}`, {
            value: value,
            target: target
        });

        if (response.data.success) {
            handleSuccess(response.data.msg);
            getData();

            // myCrm[target] = response.data.value;
        } else {
            handleError(response.data.msg);
        }
    }

    const onSortChange = ({ sortBy }) => {
        if (JSON.stringify(sortBy) !== JSON.stringify(prevSortBy.current)) {
            prevSortBy.current = sortBy;
            setSortBy(sortBy);
        }
    };

    const getInitialSortBy = () => {
        const sortBy = [];
        queryParams.getAll('sort_by').forEach((id, index) => {
            sortBy.push({ id, desc: queryParams.getAll('sort_desc')[index] === 'true' });
        });
        return sortBy;
    };

    useEffect(() => {
        if (utilisateur) {
            queryParams.set('filter_user', utilisateur.id);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [utilisateur]);

    useEffect(() => {
        if (entreprise) {
            queryParams.set('filter_entreprise', entreprise.entrepriseId);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [entreprise]);

    useEffect(() => {
        if (sortBy.length > 0) {
            queryParams.delete('sort_by');
            queryParams.delete('sort_desc');
            sortBy.forEach(sort => {
                queryParams.append('sort_by', sort.id);
                queryParams.append('sort_desc', sort.desc);
            });
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [sortBy]);

    useEffect(() => {
        getData();
    }, [user, mode, location.search]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    useEffect(() => {
        if (page) {
            queryParams.set('page', page);
            navigate(`${location.pathname}?${queryParams.toString()}`);
        }
    }, [page]);

    return (
        <div className="content_tab">
            <TitleMain text="CRM actions"/>

            <div>
                <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)}>
                    <div className={""}>
                        <div className={""}>
                            <TitleSecondary text="Filtres"/>
                        </div>
                        <div className={""}>
                            <div className={styles_field.field}>
                                <span>Utilisateur</span>
                                <SearchUtilisateur onSubmit={(u) => setUtilisateur(u)}/>
                            </div>

                            <div className={styles_field.field}>
                                <span>Entreprise</span>
                                <SearchEntreprise onSubmit={(e) => setEntreprise(e)}/>
                            </div>
                        </div>
                    </div>
                </FilterHamburgerCustom>
            </div>

            {myApiData && <>
            <CrmUserOptinTable crmUserOptin={myApiData} putOptin={putCrmOptin} serverSideSorting={true} onSortChange={onSortChange} initialSortBy={getInitialSortBy()} />
            <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalResult} />
</>}
            {/* <pre>{JSON.stringify(myApiData, null, 2)}</pre> */}
        </div>
    )
}

export default AdminCrmUserOptinPage;
